export const projectsRoutes = [
  {
    path: '/projects',
    name: 'projects',
    meta: {
      requiresAuth: true // All app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "projects" */ './Projects.vue'),
    children: [
      {
        path: 'list',
        name: 'projects-list',
        component: () =>
          import(/* webpackChunkName: "projects-list" */ './projects-list/ProjectsList.vue')
      },
      {
        path: 'create',
        name: 'create-project',
        component: () =>
          import(/* webpackChunkName: "new-project" */ './new-project/NewProject.vue')
      },
      {
        path: ':reference_number',
        name: 'project-details',
        component: () =>
          import(/* webpackChunkName: "project-details" */ './project-details/ProjectDetails.vue')
      },
      {
        path: ':project_reference_number/event-types/:reference_number',
        name: 'project-event-type-details',
        component: () =>
          import(/* webpackChunkName: "project-event-type-details" */ './project-event-type-details/ProjectEventTypeDetails.vue')
      }
    ]
  }
];
